import { MantineProvider } from "@mantine/core"
import { ModalsProvider } from "@mantine/modals"
import { QueryClientProvider } from "@tanstack/react-query"
import { ErrorBoundary } from "./-components/error-context/error-boundary.tsx"
import { queryClient } from "./queryClient.ts"
import { I18nMantineDatesProvider } from "./routes/-components/i18n-mantine-dates-provider.tsx"
import { theme } from "./theme.ts"

export function ApplicationProviders({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <MantineProvider theme={theme}>
      <ErrorBoundary
        autoReload={{ enabled: true, retries: 3, showReloadButton: true }}
      >
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <I18nMantineDatesProvider>{children}</I18nMantineDatesProvider>
          </ModalsProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </MantineProvider>
  )
}
